module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona-card-f0f925c407dce71e358e4d9698dfbba8.png";